import {
  Table as MuiTable,
  TableContainer as MuiTableContainer,
  Paper as MuiPaper,
  TableProps as MuiTableProps,
  TableFooter as MuiTableFooter,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
  TableCell as MuiTableCell,
  TableBody as MuiTableBody,
  TableRowProps as MuiTableRowProps,
  TableCellProps as MuiTableCellProps,
  TableBodyProps as MuiTableBodyProps,
  TableHeadProps as MuiTableHeadProps,
} from '@mui/material';
import clsx from 'clsx';

const TableRow = (props: MuiTableRowProps): JSX.Element => {
  return (
    <MuiTableRow
      {...props}
      className={clsx(props.className)}
      sx={{ '&:last-child td, &:last-child th': { border: 0 }, ...props.sx }}
    ></MuiTableRow>
  );
};

const TableHCell = (props: MuiTableCellProps): JSX.Element => {
  return (
    <MuiTableCell
      {...props}
      className={clsx(
        'text-xs leading-4 font-bold text-center',
        'border-0 py-3',
        props.className
      )}
    ></MuiTableCell>
  );
};

type TableCellProps = MuiTableCellProps & {
  transparent?: boolean;
};

const TableCell = ({ transparent, ...props }: TableCellProps): JSX.Element => {
  return (
    <MuiTableCell
      {...props}
      className={clsx(
        'text-15 leading-5 font-medium text-center',
        'border-0 py-3',
        { 'bg-gray-d3/50': !transparent },
        props.className
      )}
    ></MuiTableCell>
  );
};

const TableHead = (props: MuiTableHeadProps): JSX.Element => {
  return <MuiTableHead {...props}></MuiTableHead>;
};

const TableBody = (props: MuiTableBodyProps): JSX.Element => {
  return <MuiTableBody {...props}></MuiTableBody>;
};

function Table_(props: MuiTableProps) {
  return (
    <MuiTableContainer
      component={MuiPaper}
      className={clsx(
        'shadow-none overflow-x-auto',
        'w-0 min-w-full',
        props.className
      )}
    >
      <MuiTable
        {...props}
        className={clsx('border-separate border-spacing-y-2 whitespace-nowrap')}
      ></MuiTable>
    </MuiTableContainer>
  );
}

export const Table = {
  Root: Table_,
  Head: TableHead,
  Body: TableBody,
  Footer: MuiTableFooter,
  Row: TableRow,
  Cell: TableCell,
  HCell: TableHCell,
};
